// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"actions-wrapper_actionsWrapper__1TSbl","action":"actions-wrapper_action__sVF7P"};